// extracted by mini-css-extract-plugin
module.exports = {"required":"styles_required__1A0_H","label":"styles_label__1sm6R"};